import { User, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAuth } from "@/contexts/UnifiedAuthContext";
import { useTelegram } from "@/contexts/UnifiedAuthContext";
import { useNotifications } from "@/contexts/NotificationContext";
import { useTranslation } from "react-i18next";

export const AccountIdSection = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { isTelegram, telegramUser } = useTelegram();
  const { addNotification } = useNotifications();
  const [isCopying, setIsCopying] = useState(false);

  const copyProfileToClipboard = async () => {
    setIsCopying(true);

    try {
      let profileText = "";
      const createdDate = new Date().toLocaleString("ru-RU");

      if (isTelegram && telegramUser) {
        profileText = `${t('profile.account_id.clipboard_text.header')}

${t('profile.account_id.clipboard_text.app_type_telegram')}
${t('profile.account_id.clipboard_text.name', { name: `${telegramUser.first_name}${telegramUser.last_name ? ` ${telegramUser.last_name}` : ""}` })}
${telegramUser.username ? `${t('profile.account_id.clipboard_text.username', { username: telegramUser.username })}` : ""}
${t('profile.account_id.clipboard_text.telegram_id', { id: telegramUser.id })}
${t('profile.account_id.clipboard_text.system_id', { id: user?.id || t('profile.account_id.clipboard_text.undefined') })}
${telegramUser.language_code ? `${t('profile.account_id.clipboard_text.language', { lang: telegramUser.language_code.toUpperCase() })}` : ""}
${user?.email ? `${t('profile.account_id.clipboard_text.email', { email: user.email })}` : ""}

${t('profile.account_id.clipboard_text.created_date', { date: createdDate })}`;
      } else {
        profileText = `${t('profile.account_id.clipboard_text.header')}

${t('profile.account_id.clipboard_text.app_type_web')}
${t('profile.account_id.clipboard_text.email', { email: user?.email || t('profile.account_id.clipboard_text.not_specified') })}
${t('profile.account_id.clipboard_text.system_id', { id: user?.id || t('profile.account_id.clipboard_text.undefined') })}

${t('profile.account_id.clipboard_text.created_date', { date: createdDate })}`;
      }

      await navigator.clipboard.writeText(profileText);

      addNotification({
        userId: user?.id || "",
        type: "success",
        message: t('profile.account_id.copy_success'),
      });
    } catch (error) {
      console.error("Ошибка копирования:", error);
      addNotification({
        userId: user?.id || "",
        type: "error",
        message: t('profile.account_id.copy_error_desc'),
      });
    } finally {
      setIsCopying(false);
    }
  };

  return (
    <div className="flex items-center justify-between bg-muted rounded-lg p-4 border border-border">
      <div className="space-y-1">
        <div className="flex items-center gap-2">
          <User size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">
            {t('profile.account_id.label')} {user?.id || t('profile.account_id.clipboard_text.undefined')}
          </span>
        </div>
        <p className="text-xs text-muted-foreground ml-6">
          {t('profile.account_id.hint')}
        </p>
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={copyProfileToClipboard}
        disabled={isCopying}
        className="h-6 w-6 hover:bg-muted"
      >
        <Copy size={14} className={isCopying ? "animate-spin" : ""} />
      </Button>
    </div>
  );
};
